var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"navArea",attrs:{"id":"nav"}},[_c('div',{staticClass:"all-nav"},_vm._l((_vm.navs),function(nav){return _c('span',{key:nav.id,class:['nav-item', {'active': _vm.currChannel === nav.id}],on:{"click":function($event){return _vm.toNav(nav.id,nav.url, $event)}}},[_vm._v(_vm._s(nav.channelName))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }